import React, { FC } from 'react'

type Props = {
  className?: string
  color?: string
  size?: number
}

const Minus: FC<Props> = ({ className = '', color = '#14142B', size = 18 }) => (
  <span className={['anticon', 'anticon-setting', className || ''].join(' ')}>
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M20.0001 12.4999C20.0001 13.0522 19.5523 13.5 19.0001 13.5L5.00005 13.4999C4.44777 13.4999 4.00005 13.0522 4.00005 12.4999C4.00005 11.9477 4.44777 11.4999 5.00005 11.4999L19.0001 11.4999C19.5523 11.4999 20.0001 11.9477 20.0001 12.4999Z"
        fill={color}
      />
    </svg>
  </span>
)

export default Minus
